import {useParams, useRouteMatch} from 'react-router-dom';
import {DevicesAssociations} from '../../../../../../../components/devices-associations/devices-associations';
import {useOffice} from '../../../../../../../contexts/office/context';
import {ScreenPaths} from '../../../../../../../enums/screen-path';
import {CaregiverMode} from '../../../../../../../enums';

export default function SeniorDevicesSystemAdministratorOfficeScreen() {
  let {id}: {id?: string} = useParams();
  const officeContext = useOffice();
  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url} = useRouteMatch();

  return (
    <DevicesAssociations
      caregiverMode={CaregiverMode.SystemAdministrator}
      canWrite
      userId={id || ''}
      userName={officeContext.state.userForm?.user.name || ''}
      associateDeviceUrl={
        url.charAt(url.length - 1) === '/' ? `${url}associate` : `${url}/associate`
      }
      deviceRowBaseLinkUrl={`${ScreenPaths.Office}${ScreenPaths.Office_SystemAdministrator}${ScreenPaths.SystemAdministrator_Devices}`}
    />
  );
}
